import React, { ReactElement } from 'react'

import { styled } from 'styled-components'

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;

  .input {
    color: #8e92bc;
    background: transparent;
    border: 1px solid #dbdbdb;

    &:active,
    &:focus,
    &:hover {
      border: 1px solid #08a8d2;
    }

    &:disabled {
      color: #0a0a18;
      background: #f6f6f6;
      border: none;
    }
  }

  .content-password {
    display: flex;
    align-items: center;
    width: 100%;

    label {
      width: 100%;
      position: relative;
      align-items: center;
      display: flex;

      .password-button {
        position: absolute;
        right: 10px;
      }
    }
    svg {
      margin-left: 10px;
      cursor: pointer;
      width: 22px;
      color: #8e92bc;
    }

    input {
      color: #8e92bc;
      background: transparent;
      border: 1px solid #dbdbdb;

      &:active,
      &:focus,
      &:hover {
        border: 1px solid #08a8d2;
      }

      &:disabled {
        color: #0a0a18;
        background: #f6f6f6;
        border: none;
      }
    }
  }

  &.push-to-bottom {
    max-height: 100px;
    margin-top: auto;
  }

  .col-md {
    width: 55%;
  }
`

export const Label = styled.label`
  font-size: 12px;
  color: #6b7280;

  @media screen and (max-width: 768px) {
    /* text-align: center; */
    &.empty-line {
      margin-bottom: 12px;
    }
  }
`

const FormField = ({
  id,
  label,
  children,
  className,
  labelClass,
}: {
  id: string
  label: string
  children: ReactElement
  className?: string
  labelClass?: string
}) => {
  return (
    <Field key={id} className={className}>
      <Label className={labelClass} htmlFor={id}>
        {label}
      </Label>
      {children}
    </Field>
  )
}

export default FormField
